<template>
  <div class="layout" id="TAB-CONTENT">
    <div class="tab">
      <div
        class="tab-item"
        :class="currentIndex == index ? 'active' : ''"
        v-for="(tab, index) in tabs"
        :key="index"
        @click="handleTabClick(tab, index)"
      >
        {{ tab.text }}
      </div>
    </div>
    <div class="tab-pane">
      <div class="tab-content" v-show="currentIndex == 0">
        <Syzl />
      </div>
      <div class="tab-content" v-show="currentIndex == 1">
        <Zhsq />
      </div>
      <div class="tab-content" v-show="currentIndex == 2">
        <Zhyq />
      </div>
      <div class="tab-content" v-show="currentIndex == 3">
        <Zhxy />
      </div>
    </div>
  </div>
</template>

<script>
import Zhsq from "./zhsq.vue";
import Syzl from "./syzl.vue";
import Zhyq from "./zhyq.vue";
import Zhxy from "./zhxy.vue";
export default {
  name: "layout",
  components: {
    Zhsq,
    Syzl,
    Zhyq,
    Zhxy
  },
  watch: {
    $route(val) {
      const tabIndex = val.query.tab;
      this.currentIndex = tabIndex;
    }
  },
  computed: {
    tabIndex() {
      return this.$route.query.tab;
    }
  },
  data() {
    return {
      currentIndex: 0,
      tabs: [
        { text: "市域治理" },
        { text: "智慧社区" },
        { text: "智慧园区" },
        { text: "智慧校园" }
      ]
    };
  },
  methods: {
    handleTabClick(item, index) {
      this.currentIndex = index;
    }
  }
};
</script>

<style lang="less" scoped>
.layout {
  .tab {
    padding-top: 5rem;
    padding-bottom: 3rem;
    display: flex;
    justify-content: center;
    .tab-item {
      width: 13rem;
      height: 4.8rem;
      line-height: 4.8rem;
      border: 1px solid #999999;
      font-size: 1.1rem;
      color: #333333;
      text-align: center;
      background-color: #ffffff;
      &.active {
        color: #ffffff;
        background: linear-gradient(219deg, #3063af 0%, #6fbcf0 100%);
        border: 1px solid #ffffff;
      }
      &:not(:last-child) {
        margin-right: 3rem;
      }
    }
  }
}
</style>
